import ViewerContainer from 'app/containers/ViewerContainer/ViewerContainer';
import { CONTENT_TYPES } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import PdfContentNavigation from './PdfContentNavigation';
import usePdfContent from './usePdfContent';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PdfContent({ url, onDocumentLoadSuccess, pageNumber, contentGuid, pagesRange, onClickFullScreen, variant, contentType }) {
  const {
    containerRef,
    containerSize,
    currentPageForDisplay,
    goToNextPage,
    goToPreviousPage,
    hasError,
    isNextDisabled,
    isPreviousDisabled,
    onLoadError,
    onLoadSuccess,
    pagesToRender,
    showNavigation,
    totalPagesForDisplay,
    urlResource,
  } = usePdfContent({ contentGuid, onDocumentLoadSuccess, pageNumber, pagesRange, url, variant, contentType });

  function handleFullScreen() {
    window.open(`/viewerfull/${contentGuid}`, '_blank');
  }

  const effectiveOnClickFullScreen = onClickFullScreen || (contentGuid ? handleFullScreen : null);

  return (
    <div className={`pdf-content ${variant ? `pdf-content--${variant}` : ''}`}>
      {showNavigation && (
        <PdfContentNavigation
          currentPage={currentPageForDisplay}
          disabled={hasError}
          isNextDisabled={isNextDisabled}
          isPreviousDisabled={isPreviousDisabled}
          onClickNext={goToNextPage}
          onClickFullScreen={effectiveOnClickFullScreen}
          onClickPrevious={goToPreviousPage}
          totalPages={totalPagesForDisplay}
        />
      )}

      {contentType !== CONTENT_TYPES.OFFICE && (
        <div className="pdf-content__container" ref={containerRef}>
          {urlResource && containerSize > 0 && (
            <Document file={{ url: urlResource }} onLoadError={onLoadError} onLoadSuccess={onLoadSuccess}>
              {pagesToRender.map((pageNum, index) => (
                <Page
                  key={`page-${pageNum}-${index}`}
                  pageNumber={pageNum}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                  {...(variant === 'full-height' ? { height: containerSize } : { width: containerSize })}
                />
              ))}
            </Document>
          )}
        </div>
      )}

      {contentType === CONTENT_TYPES.OFFICE && (
        <div className="office-content__container" ref={containerRef}>
          <ViewerContainer
            config={{ pdfConfig: [], disabledFetchData: true }}
            contentGuid={contentGuid}
            showEmbed
            standalone={true}
            shouldEnableFullWidth={true}
            shouldConsumption={false}
          />
        </div>
      )}
    </div>
  );
}

PdfContent.propTypes = {
  contentGuid: PropTypes.string,
  onClickFullScreen: PropTypes.func,
  onDocumentLoadSuccess: PropTypes.func,
  pageNumber: PropTypes.number,
  pagesRange: PropTypes.array,
  url: PropTypes.string,
  variant: PropTypes.oneOf(['full-width', 'full-height']),
  contentType: PropTypes.string,
};

PdfContent.defaultProps = {
  contentGuid: null,
  onClickFullScreen: null,
  onDocumentLoadSuccess: () => {},
  pageNumber: null,
  pagesRange: null,
  variant: 'full-width',
};

export default PdfContent;
